import React, { HTMLAttributes } from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphTextEntity } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphTextEntity;
}

const ParagraphText: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('ParagraphText');

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');

  return (
    <article className={joinClasses(buildClass(), className)}>
      {title.length > 0 && (
        <div className={buildClass('title')}>
          <h2>{title}</h2>
        </div>
      )}

      {text.length > 0 && (
        <div className={buildClass('body')}>
          <WysiwygField
            property="schema:text"
            html={text}
          />
        </div>
      )}
    </article>
  );
};

export default ParagraphText;
